import { writable } from "svelte/store";

export const showTermsOfServices = writable(false);
export const showPrivacy = writable(false);
